import { useEffect, useState } from "react";
import { api, brl } from "../lib/api";
import { AdminGate, AdminShell } from "./AdminGate";
import { Loader2, UserRound } from "lucide-react";

function Clientes({ user }) {
  const [list, setList] = useState(null);

  useEffect(() => {
    api.get("/admin/clientes").then((r) => setList(r.data.clientes)).catch(() => setList([]));
  }, []);

  return (
    <AdminShell user={user} title="Clientes">
      <div className="px-4 mt-4 space-y-3" data-testid="admin-clientes-page">
        {list === null && <div className="flex justify-center py-14"><Loader2 className="w-8 h-8 animate-spin text-[#F5B301]" /></div>}
        {list !== null && list.length === 0 && <p className="text-center text-sm text-slate-400 py-14" data-testid="clientes-empty">Nenhum cliente ainda.</p>}
        {(list || []).map((c) => (
          <div key={c.telefone} className="bg-white rounded-2xl border border-slate-100 shadow-sm p-4" data-testid={`cliente-${c.telefone}`}>
            <div className="flex items-center gap-2.5">
              <div className="w-9 h-9 rounded-full bg-navy flex items-center justify-center shrink-0">
                <UserRound className="w-4 h-4 text-[#F5B301]" />
              </div>
              <div className="flex-1">
                <p className="font-heading font-bold text-navy text-sm">{c.nome}</p>
                <p className="text-[11px] text-slate-400">{c.telefone}</p>
              </div>
              {c.reservas >= 2 && (
                <span className="text-[9px] font-bold bg-gold-light border border-[#F5B301]/60 text-navy px-2 py-0.5 rounded-full">RECORRENTE</span>
              )}
            </div>
            <div className="flex gap-4 mt-2 text-[11px] text-slate-500">
              <span>{c.orcamentos} orçamento(s)</span>
              <span>{c.reservas} reserva(s)</span>
              <span className="font-bold text-navy">{brl(c.total)} contratado</span>
            </div>
          </div>
        ))}
      </div>
    </AdminShell>
  );
}

export default function AdminClientes() {
  return <AdminGate>{(user) => <Clientes user={user} />}</AdminGate>;
}
